import { RouterProvider } from 'react-router-dom'; //Router Provider to use react-router @V6.8
import router from './core/routes/Routes'; //Seperated Routing File
import './utils/localization/i18next'; //Localization instance passed
// Components
import { ToastContainer } from 'react-toastify';

// Styling
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './App.css';

import { useAppSelector } from './core/hooks/hooks';
import { getLoader } from './core/store/slices/loaderSlice';
import { socketConnection } from './utils/api/socket';
import DialogComponent from './components/ReusableComponent/Dialogue/Dialogue';
import { getDialogue } from './core/store/slices/dialogueSlice';
import { PortraitComponent } from './GlobalDigitalStyle/PortraitSceen.style';
import rotation from '../src/assets/images/rotation.png';
function App() {
	const loader = useAppSelector(getLoader);
	const dialogue = useAppSelector(getDialogue);

	return (
		<>
			{' '}
			<div className="portrait:hidden">
				<RouterProvider router={router} />
				<ToastContainer limit={3} />
				{dialogue.show && <DialogComponent />}
			</div>
			<div className="landscape:hidden">
				<PortraitComponent>
					<div className="rotation text-center">
						<img src={rotation} alt="" />
						<p className="text-[1.5em]	text-zinc-100">
							This Web Application Under The Landscape Mode Will Not Be Visible. Please Change Your Mode To Can View The Web App
						</p>
					</div>
				</PortraitComponent>
			</div>
			{/* {loader.show && <Spinner />} */}
		</>
	);
}

export default App;
